import { useState, memo } from "react"
import { ReactComponent as ArrowDropDownIcon } from 'assets/icons/arrow_drop_down.svg'
import { ReactComponent as ArrowDropUpIcon } from 'assets/icons/arrow_drop_up.svg'
import { motion, AnimatePresence } from "motion/react"
import { APP_CONFIG } from "constants/constants";

interface SidebarGroupProps {
	children: React.ReactNode,
	title: string,
	icon?: React.ReactNode,
	closeOnClick?: boolean,
	allwaysOpen?: boolean
}

const SidebarGroup: React.FC<SidebarGroupProps> = ({ children, title, icon, closeOnClick, allwaysOpen = false }) => {
		const [isOpen, setIsOpen] = useState(false)

		const handleToggle = () => {
			setIsOpen(!isOpen)
		}

		/*const handleClick = () => {
			if (isOpen && closeOnClick) {
				setIsOpen(false)
			}
		}*/

		// Define Tailwind classes as constants
		const sidebarGroupClasses = isOpen ? "" : "";
		const sidebarGroupTitleClasses = `grid grid-cols-[min-content_auto_min-content] h-10 items-center px-8 gap-2 mb-2 ${allwaysOpen ? "" : "cursor-pointer"} [&>svg]:fill-black text-base ${icon ? "" : "font-bold"}`;
		const rowTextClasses = `whitespace-nowrap select-none ${allwaysOpen ? "text-gray-700" : "text-black"}`
		const sidebarIconClasses = "fill-black";

		return (
			<div className={sidebarGroupClasses}>
				<div className={sidebarGroupTitleClasses} onClick={handleToggle}>
					{icon ? icon : null}
					<span className={rowTextClasses}>{title}</span>
					{allwaysOpen ? null : isOpen ? <ArrowDropUpIcon className={sidebarIconClasses} /> : <ArrowDropDownIcon className={sidebarIconClasses} />}
				</div>
				{/* This section uses a quick-fix by Copilot */}
				<AnimatePresence>
					{allwaysOpen ? (
						<motion.div
							key="always-open"
							initial={false}
							animate={{ height: 'auto' }}
							exit={{}}
							className="overflow-hidden"
						>
							{children}
						</motion.div>
					) : isOpen && (
						<motion.div
							key="collapsible"
							initial={{ height: '0px' }}
							animate={{
								height: `auto`,
								transition: { duration: APP_CONFIG.SHORT_ENTER_ANIMATION_DURATION }
							}}
							exit={{
								height: '0px',
								transition: { duration: APP_CONFIG.SHORT_EXIT_ANIMATION_DURATION }
							}}
							className="overflow-hidden"
						>
							{children}
						</motion.div>
					)}
				</AnimatePresence>
			</div>
		)
	}

export default memo(SidebarGroup)

